import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

import PatientDetails from "./details";
import PatientClaims from "./claims_admin";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tabBar: {
    boxShadow: 'none',
    backgroundColor: '#eaeaea',
    color: 'black',
    //paddingTop: 8,
  }
});

class Patient extends React.Component {
    _isMounted = false;

  state = {
    value: 0,
    patient_id: this.props.match.params.patient_id,
  };

  constructor(props){
      super(props);
      this.props = props;
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }  

  componentDidUpdate(prevProps){
    if (this.props.match.params.patient_id !== prevProps.match.params.patient_id) {
        this.setState({patient_id: this.props.match.params.patient_id});
    }
}  

  render() {
    const { classes } = this.props;
    const { value } = this.state;
    
    return (
        <div>
          <AppBar position="static" className={classes.tabBar}>
            <Tabs value={value} onChange={this.handleChange}>
              <Tab label="Details"/>
              {this.state.patient_id ? <Tab label="Claims"/>:null }
            </Tabs>
          </AppBar>     
          {value === 0 && <TabContainer><PatientDetails appstate={this.props.parentstate} patient_id={this.state.patient_id} socket={this.props.socket} history={this.props.history} /></TabContainer>}
          {value === 1 && <TabContainer><PatientClaims appstate={this.props.parentstate} patient_id={this.state.patient_id} socket={this.props.socket}/></TabContainer>}
        </div>
    );
  }
}

export default withStyles(styles)(Patient);